import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import Pushy from 'pushy-sdk-web';

export const login = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
    
    axios.post('/login/index.php', payload)
    .then(res => {
        console.log(JSON.stringify(res.data))
        if(res.data.status) {
            localStorage.setItem('accessToken', res.data.access_token)
            dispatch('checkAccessToken', { navigate: true })
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const masterLogin = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/appAdmin/masterLogin.php', payload)
    .then(res => {
        
        if(res.data.status) {
            localStorage.setItem('accessToken', res.data.access_token)
            dispatch('checkAccessToken', { navigate: true })
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error-1', displayHTML: true});
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-2'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const forgotPassword = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/login/forgotPassword.php', payload)
    .then(res => {
        
        if(res.data.status) {
            commit('displayMessageAlert', {message: res.data.message, type: 'Message', displayHTML: true});
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const generateGoogleAuthURL = ({commit}) => {
    
    axios.get('/googleSync/contact/generateAuthURL.php', accessTokenInfo.accessTokenInfo())
    .then(res => { 
        if(res.data.status) {
            //commit('setGoogleAuthCode', res.data.response)
            let popupWinWidth = 400
            let popupWinHeight = 400

            let left = (screen.width - popupWinWidth) / 2;
            let top = (screen.height - popupWinHeight) / 4;
              
            window.open(res.data.response, "Google Auth", 
                    'resizable=yes, width=' + popupWinWidth
                    + ', height=' + popupWinHeight + ', top='
                    + top + ', left=' + left);

        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    
}

export const generateGoogleAccessToken = ({commit}, payload) => {
    
    axios.post('/googleSync/contact/generateAccessToken.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        if(res.data.status) {
            commit('displayMessageAlert', {message: "Google contact is now synced, please refresh the app to see the sync status.", type: 'Message', displayHTML: true});
            window.close()
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Message', displayHTML: true});
        }       
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    
}

export const checkAccessToken = ({commit, dispatch}, payload) => {
    
    console.log(JSON.stringify(accessTokenInfo.accessTokenInfo()))
    commit('toggleLoadingState', true)
    axios.get('/login/checkAccessToken.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        dispatch('loadCountryList')
        dispatch('loadShipmentPartner')
        dispatch('fetchBookmarks')
        dispatch('loadTallyGroup')
        dispatch('loadTallySubGroup')
        if(res.data.status) {
            
            let response = res.data
            response.navigate = payload.navigate
            if(payload.device_token !== undefined && payload.device_token.length>5) {
                dispatch('registerOrCheckDevice', {tenant_id: response.tenant_id, user_id: response.user_id, machine_id: payload.device_token})
            } else {
                dispatch('initiatePushNotification', {tenant_id: response.tenant_id, user_id: response.user_id})                
            }
            commit('setAccessToken', response)             
        } else {
            if(res.data.message !== undefined && res.data.message.length>0) {
                commit('displayMessageAlert', {message: res.data.message, type: 'Error'})            
            }
            dispatch('logout')
        }

    })
    .catch(error => {
        console.log(error)
        //commit('displayMessageAlert', {message: error, type: 'Error-3'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const initiatePushNotification = ({commit, dispatch}, payload) => {
    
    /** REGISTER OR CHECK DEVICE **/
    Pushy.register({ appId: '629d9ae4ca130a4f54f56b2b' }).then(function (deviceToken) {
        
        Pushy.setNotificationListener( (data) => {
            
            commit('displayMessageAlert', {message: data.message, type: 'Alert'})

        });   
        localStorage.setItem('device_token_id', deviceToken)
        const deviceTokenPayload = {tenant_id: payload.tenant_id, user_id: payload.user_id, machine_id: deviceToken}
        dispatch('registerOrCheckDevice', deviceTokenPayload)

    }).catch(function (err) {
        //commit('displayMessageAlert', {message: err+' We strongly recommend you to use Chrome, Opera or Mozilla to seamlessly receive alerts on this device. In addition, if you have activated ad-blockers, it may result in non-delivery of alerts on this device.', type: 'Error-Device-Reg'})
        dispatch('registerOrCheckDevice', {tenant_id: payload.tenant_id, user_id: payload.user_id, machine_id: 'NA'})
    });
    /** END **/
    
}


export const registerOrCheckDevice = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/login/registerDevice.php', payload)
    .then(res => {

        console.log(JSON.stringify(res.data))

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-3'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const changePassword = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/login/changePassword.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            dispatch('logout')               
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error'})
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const updatePageLimit = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/preferences/updatePageLimit.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
    
        commit('setMasterPageLimit', res.data)

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

/*** MASTER DATA ***/


export const loadTallyGroup = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/masterData/loadTallyGroup.php', payload)
    .then(res => {
        
        commit('setTallyGroup', res.data.tally_group_list)              

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const loadTallySubGroup = ({commit}) => {

    commit('toggleLoadingState', true)
    axios.get('/masterData/loadTallySubGroup.php')
    .then(res => {
        
        commit('setTallySubGroup', res.data.tally_sub_group_list)              

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const loadCountryList = ({commit}) => {

    commit('toggleLoadingState', true)
    axios.get('/masterData/loadCountryList.php')
    .then(res => {
        //console.log(JSON.stringify(res.data))
        commit('setCountryList', res.data.country_list)              
    })
    .catch(error => {
        console.log(JSON.stringify(error))
        commit('displayMessageAlert', {message: "Error "+error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const loadProvinceList = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/masterData/loadProvinceList.php', payload)
    .then(res => {
        
        commit('setProvinceList', res.data.province_list)              

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const loadCityList = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/masterData/loadCityList.php', payload)
    .then(res => {
        
        commit('setCityList', res.data.city_list)              

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const loadCommunicationVariables = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/masterData/loadCommunicationVariables.php', payload)
    .then(res => {
        
        commit('setCommunicationList', res.data.communication_variables)              

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const loadMasterModuleList = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/masterData/loadMasterModuleList.php', payload)
    .then(res => {
        
        commit('setMasterModuleList', res.data.module_list)              

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const loadFabricWidthList = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/masterData/loadFabricWidthList.php', payload)
    .then(res => {
        
        commit('setFabricWidthList', res.data.list)              

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const loadShipmentPartner = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/masterData/loadShipmentPartner.php', payload)
    .then(res => {
        
        commit('setTrackingShipmentPartnerList', res.data.list)              

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const loadSalutation = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/masterData/loadSalutation.php', payload)
    .then(res => {
        
        commit('setSalutationList', res.data.list)              

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const loadUOMMasterList = ({commit}) => {

    commit('toggleLoadingState', true)
    axios.get('/masterData/loadUOMMasterList.php')
    .then(res => {
        
        commit('setUOMList', res.data.list)              

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const loadFabricGSMList = ({commit}) => {

    commit('toggleLoadingState', true)
    axios.get('/masterData/loadFabricGSMList.php')
    .then(res => {
        
        commit('setFabricGSMList', res.data.list)              

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const fetchEStoreMenuList = ({commit}) => {

    commit('toggleLoadingState', true)
    axios.get('/masterData/eStoreMenuList.php')
    .then(res => {
        commit('setEStoreMenuList', res.data.list)              
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const loadDashboard = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)

    axios.post('/dashboard/index.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('setDashboard', res.data.response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-Dashboard'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const saveBookmark = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)

    axios.post('/login/bookmark/saveBookmark.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        dispatch('fetchBookmarks')
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-access-token'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const fetchBookmarks = ({commit}) => {
    
    axios.get('/login/bookmark/fetchBookmarks.php', accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('setBookmarkList', res.data.response)        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-access-token'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}


export const saveMasterSearchQuery = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)

    axios.post('/login/saveMasterSearchQuery.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        dispatch('fetchMasterSearchQuery', {page_id: payload.page_id})
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-access-token'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const fetchMasterSearchQuery = ({commit}, payload) => {
    
    axios.post('/login/fetchMasterSearchQuery.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('setMasterQueryList', res.data.response)        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-access-token'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const deleteMasterSearchQuery = ({commit, dispatch}, payload) => {
    
    axios.post('/login/deleteMasterSearchQuery.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 

        dispatch('fetchMasterSearchQuery', {page_id: payload.page_id})
        commit('toggleLoadingState', true)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-access-token'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

/*** END MASTER DATA ***/

export const logout = ({commit}) => {
    
    commit('toggleLoadingState', true)

    axios.get('/login/logout.php', accessTokenInfo.accessTokenInfo())
    .then(res => { 
        if(res.data.status) {
            commit('clearAuthData')

        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error'})
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-access-token'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const fetchMonthlyAppointments = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/dashboard/taskCalendar.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('setTaskCalendar', res.data.response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-access-token'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const loadAppointmentList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/dashboard/taskCalendarEventList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('setTaskCalendarEventList', res.data.response)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-access-token'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const copyInformation = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    /*ipcRenderer.invoke('copyToClipboard', { data: payload }).then( () => {
        commit('displaySuccessNotification', {message: 'Data Copied!!!'});
    })*/
    navigator.clipboard.writeText(payload);
    setTimeout(() => {
        commit('displaySuccessNotification', {message: 'Data Copied!!!'});    
    }, 200);
    
    commit('toggleLoadingState', false)
}

export const downloadCSV = ({}, payload) => {
    
    var items = payload.data;

    // Convert Object to JSON
    var jsonObject = JSON.stringify(items);
            
    var array = typeof jsonObject != 'object' ? JSON.parse(jsonObject) : jsonObject;
    var str = '';

    for (var i = 0; i < array.length; i++) {
        var line = '';
        for (var index in array[i]) {
            if (line != '') line += ','

            let strValue = array[i][index]
            //strValue.length>0 ? strValue : ' '

            line += strValue//.replace(',', ' ');
        }
        
        str += line + '\r\n';
    }

    var csv = str;
            
    var uri = 'data:text/csv;charset=utf-8,' + escape(csv);         
    var link = document.getElementById('csvLink')
    link.href = uri;
    link.download = payload.title+".csv";
    link.click();

}

export const loadTallyData = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post(payload.url, payload.request, accessTokenInfo.accessTokenInfo())
    .then(res => { 
        commit('setTallyImport', res.data)
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-access-token'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}


// WEBPACK FOOTER //
// ./src/store/modules/master/actions.js